<div class="survey-details" *ngIf="selectedSurvey">
  <div class="main-content-container">
    <div class="details-wrapper flex flex-column">
      <div class="top-info-section" *ngIf="selectedSurvey.responsiblePerson || selectedSurvey.surveyTypeName" [ngClass]="{'has-map-icon': selectedSurvey.mapInfo?.surveyPolygon, 'en': currentLang === 'en', 'he': currentLang === 'he'}">
        <div class="info-content">
          <div class="info-row" *ngIf="selectedSurvey.responsiblePerson">
            <span class="info-label">{{ 'iaa.app.survey.responsibleForObligations' | translate }}:</span>
            <span class="info-value">
              <span 
                class="responsible-link"
                role="button"
                tabindex="0"
                [attr.aria-label]="'View surveys by ' + getPersonName(selectedSurvey.responsiblePerson)"
                (click)="handlePersonClick(selectedSurvey.responsiblePerson)"
                (keydown.enter)="handlePersonClick(selectedSurvey.responsiblePerson)"
                (keydown.space)="handlePersonClick(selectedSurvey.responsiblePerson); $event.preventDefault()">
                {{ getPersonName(selectedSurvey.responsiblePerson) }}
              </span>
            </span>
          </div>
          <div class="info-row" *ngIf="selectedSurvey.surveyTypeName">
            <span class="info-label">{{ 'iaa.app.survey.surveyType' | translate }}:</span>
            <span class="info-value">
              {{ selectedSurvey.surveyTypeName }}<span *ngIf="selectedSurvey.surveySubtypeName"> - {{ selectedSurvey.surveySubtypeName }}</span>
            </span>
          </div>
        </div>
        <div class="survey-map-icon" *ngIf="selectedSurvey.mapInfo?.surveyPolygon">
          <i class="pi pi-map-marker action-icon" 
             [ngClass]="{'active': selectedSurvey.entityId === selectedEntityId}"
             role="button"
             tabindex="0"
             [attr.aria-label]="'iaa.app.survey.showSurveyOnMap' | translate"
             (click)="onMapIconClick(selectedSurvey.entityId, 'survey', $event)"
             (keydown.enter)="onMapIconClick(selectedSurvey.entityId, 'survey', $event)"
             (keydown.space)="onMapIconClick(selectedSurvey.entityId, 'survey', $event); $event.preventDefault()"
             title="{{ 'iaa.app.survey.showSurveyOnMap' | translate }}"></i>
        </div>
      </div>

      <!-- Licenses Section -->
      <details [open]="true" *ngIf="selectedSurvey.licenses && selectedSurvey.licenses.length > 0">
        <summary
          [attr.aria-label]="('iaa.app.survey.licenses' | translate) + ' (' + selectedSurvey.licenses.length + ')'">
          <div class="button">
            <div>{{ 'iaa.app.survey.licenses' | translate }} ({{ selectedSurvey.licenses.length }})</div>
            <div class="icons">
              <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }" aria-hidden="true"></i>
              <i class="pi pi-angle-down icon-clicked" aria-hidden="true"></i>
            </div>
          </div>
        </summary>

        <!-- Unauthorized Content Warning -->
        <div *ngIf="hasUnauthorizedContentForType('licenses')"
          role="alert"
          [ngClass]="{'unauthorized':true,'en': currentLang === 'en','he': currentLang === 'he'}">
          <img src="assets/view-restriction-icon.svg" class="unauthorized-icon" alt="" role="presentation">
          <div
            [ngClass]="{'unauthorized-text':true,'en': currentLang === 'en','he': currentLang === 'he'}">
            {{ 'iaa.app.results.licensesNotDisplayed' | translate:
            {numberOfAllEntitiesUnauthorized: getUnauthorizedCountForType('licenses')} }}
            <button class="unauthorized-link" 
              (click)="handleOpenDialog()"
              (keydown.enter)="handleOpenDialog()" 
              (keydown.space)="handleOpenDialog(); $event.preventDefault()"
              tabindex="0"
              [attr.aria-label]="'iaa.app.results.viewListLicenses' | translate">
              <span class="unauthorized-link">{{'iaa.app.results.viewListLicenses' | translate}}</span> &gt;
            </button>
          </div>
        </div>

        <div class="table-container" role="table" [attr.aria-label]="'iaa.app.survey.licenses' | translate">
          <div class="table-row header" role="row">
            <div class="table-cell" role="columnheader">{{ 'iaa.app.survey.licenseNumber' | translate }}</div>
            <div class="table-cell" role="columnheader">{{ 'iaa.app.survey.surveyors' | translate }}</div>
            <div class="table-cell" aria-hidden="true"></div>
          </div>
          <div *ngFor="let license of selectedSurvey.licenses" class="table-row" role="row">
            <div class="table-cell" role="cell"><bdi>{{ license.licenseLongName }}</bdi></div>
            <div class="table-cell" role="cell">
              <span *ngFor="let excavatorGroup of license.excavatorGroups; let isLast = last">
                <span *ngFor="let excavator of excavatorGroup.excavators; let isLastExcavator = last">
                  <span 
                    class="surveyor-link"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="'View surveys by ' + (currentLang === 'he' ? excavator.nameHebrew : excavator.nameEnglish)"
                    (click)="handlePersonClick(excavator)"
                    (keydown.enter)="handlePersonClick(excavator)"
                    (keydown.space)="handlePersonClick(excavator); $event.preventDefault()">
                    {{ currentLang === 'he' ? (excavator.nameHebrew || excavator.nameEnglish) : (excavator.nameEnglish || excavator.nameHebrew) }}
                  </span><span *ngIf="!isLastExcavator">, </span>
                </span>
                <span *ngIf="excavatorGroup.excavators.length > 0" class="institution-name"> ({{ getInstitutionName(excavatorGroup) }})</span><span *ngIf="!isLast">; </span>
              </span>
            </div>
            <div class="table-cell" aria-hidden="true">
              <div class="icon-container">
                <i class="pi pi-map-marker action-icon" 
                   [ngClass]="{'active': license.licenseId === selectedEntityId}"
                   *ngIf="license.shapes && license.shapes.length > 0"
                   role="button"
                   tabindex="0"
                   [attr.aria-label]="'iaa.app.survey.showOnMap' | translate"
                   (click)="onMapIconClick(license.licenseId, 'license', $event)"
                   (keydown.enter)="onMapIconClick(license.licenseId, 'license', $event)"
                   (keydown.space)="onMapIconClick(license.licenseId, 'license', $event); $event.preventDefault()"
                   title="{{ 'iaa.app.survey.showOnMap' | translate }}"></i>
              </div>
            </div>
          </div>
        </div>
      </details>

      <!-- Yazam Reports Section -->
      <details [open]="selectedSurvey.yazamReports.length === 1" *ngIf="selectedSurvey.yazamReports && selectedSurvey.yazamReports.length > 0">
        <summary
          [attr.aria-label]="('iaa.app.survey.yazamReports' | translate) + ' (' + selectedSurvey.yazamReports.length + ')'">
          <div class="button">
            <div>{{ 'iaa.app.survey.yazamReports' | translate }} ({{ selectedSurvey.yazamReports.length }})</div>
            <div class="icons">
              <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }" aria-hidden="true"></i>
              <i class="pi pi-angle-down icon-clicked" aria-hidden="true"></i>
            </div>
          </div>
        </summary>

        <!-- Unauthorized Content Warning -->
        <div *ngIf="hasUnauthorizedContentForType('reports')"
          role="alert"
          [ngClass]="{'unauthorized':true,'en': currentLang === 'en','he': currentLang === 'he'}">
          <img src="assets/view-restriction-icon.svg" class="unauthorized-icon" alt="" role="presentation">
          <div
            [ngClass]="{'unauthorized-text':true,'en': currentLang === 'en','he': currentLang === 'he'}">
            {{ 'iaa.app.results.licensesNotDisplayed' | translate:
            {numberOfAllEntitiesUnauthorized: getUnauthorizedCountForType('reports')} }}
            <button class="unauthorized-link" 
              (click)="handleOpenDialog()"
              (keydown.enter)="handleOpenDialog()" 
              (keydown.space)="handleOpenDialog(); $event.preventDefault()"
              tabindex="0"
              [attr.aria-label]="'iaa.app.results.viewListLicenses' | translate">
              <span class="unauthorized-link">{{'iaa.app.results.viewListLicenses' | translate}}</span> &gt;
            </button>
          </div>
        </div>

        <div class="table-container" role="table" [attr.aria-label]="'iaa.app.survey.yazamReports' | translate">
          <div class="table-row header" role="row">
            <div class="table-cell" role="columnheader">{{ 'iaa.app.survey.report' | translate }}</div>
            <div class="table-cell" role="columnheader">{{ 'iaa.app.survey.licenseNumber' | translate }}</div>
            <div class="table-cell" aria-hidden="true"></div>
          </div>
          <div *ngFor="let report of selectedSurvey.yazamReports" class="table-row" role="row">
            <div class="table-cell" role="cell">
              <span class="link-note" 
                *ngIf="report.viewUrl" 
                (click)="openUrl(report.viewUrl)" 
                (keydown.enter)="openUrl(report.viewUrl)" 
                (keydown.space)="openUrl(report.viewUrl); $event.preventDefault()"
                tabindex="0" 
                role="button"
                [attr.aria-label]="'View ' + ((report.reportTitle || {hebrew: '', english: ''}) | translateLang | async)">
                {{ (report.reportTitle || {hebrew: '', english: ''}) | translateLang | async }}
              </span>
              <span *ngIf="!report.viewUrl">{{ (report.reportTitle || {hebrew: '', english: ''}) | translateLang | async }}</span>
            </div>
            <div class="table-cell" role="cell">
              <span *ngIf="report.licenses && report.licenses.length > 0">
                <span *ngFor="let license of report.licenses; let isLast = last">
                  <bdi>{{ license.licenseLongName }}</bdi><span *ngIf="!isLast">, </span>
                </span>
              </span>
              <span *ngIf="!report.licenses || report.licenses.length === 0"><bdi>{{ report.licenseNumber }}</bdi></span>
            </div>
            <div class="table-cell" aria-hidden="true">
              <div class="icon-container">
                <i class="pi pi-eye action-icon" 
                   *ngIf="report.viewUrl"
                   role="button"
                   tabindex="0"
                   [attr.aria-label]="'iaa.app.survey.view' | translate"
                   (click)="openUrl(report.viewUrl)"
                   (keydown.enter)="openUrl(report.viewUrl)"
                   (keydown.space)="openUrl(report.viewUrl); $event.preventDefault()"
                   title="{{ 'iaa.app.survey.view' | translate }}"></i>
                <i class="pi pi-map-marker action-icon" 
                   [ngClass]="{'active': report.entityId === selectedEntityId}"
                   *ngIf="report.shapes && report.shapes.length > 0"
                   role="button"
                   tabindex="0"
                   [attr.aria-label]="'iaa.app.survey.showOnMap' | translate"
                   (click)="onMapIconClick(report.entityId, 'report', $event)"
                   (keydown.enter)="onMapIconClick(report.entityId, 'report', $event)"
                   (keydown.space)="onMapIconClick(report.entityId, 'report', $event); $event.preventDefault()"
                   title="{{ 'iaa.app.survey.showOnMap' | translate }}"></i>
              </div>
            </div>
          </div>
        </div>
      </details>

    </div><!-- End details-wrapper -->

    <!-- Images Section (Orthophotos) -->
    <app-image-gallery 
      *ngIf="surveyImages?.length" 
      [thumbnails]="surveyImageThumbnails" 
      [images]="surveyImages" 
      [objectName]="getSurveyName()"
      class="gallery"/>
  </div><!-- End main-content-container -->

  <!-- Unauthorized Dialog -->
  <app-unauthorized-dialog
    *ngIf="isUnauthorizedDialogOpen"
    [unauthorizedLicenses]="processedUnauthorizedLicenses"
    [isOpen]="isUnauthorizedDialogOpen"
    [currentLanguage]="currentLang"
    (onClose)="handleCloseDialog()">
  </app-unauthorized-dialog>
</div>
